"use client";

/**
 * GA4 via next/script with strategy="lazyOnload".
 *
 * afterInteractive still evaluates gtag during the Lighthouse window
 * (~200–280ms scripting). lazyOnload waits until the browser is free after
 * load so LCP / Speed Index / TBT stay clear of gtag work.
 *
 * strategy="worker" (Partytown) stays off: next.config experimental
 * nextScriptWorkers is false because Partytown is App-Router-unsupported
 * in our Next version — enabling it would expect a worker runtime we do
 * not ship.
 */

import Script from "next/script";

type LazyGoogleAnalyticsProps = {
  gaId: string;
};

export function LazyGoogleAnalytics({ gaId }: LazyGoogleAnalyticsProps) {
  return (
    <>
      <Script
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId}`}
        strategy="lazyOnload"
      />
      <Script id="ga4-lazy-init" strategy="lazyOnload">
        {`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId}');
        `}
      </Script>
    </>
  );
}
